import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { HelpCircle } from "lucide-react";

// Visible FAQ accordion + matching FAQPage JSON-LD (language-specific) for rich snippets.
export const FaqSection = ({ faqs, lang = "de", dark = false }) => {
  if (!faqs || !faqs.length) return null;
  const heading = lang === "de" ? "Häufige Fragen" : "Frequently Asked Questions";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    inLanguage: lang === "de" ? "de-CH" : "en",
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };
  return (
    <section className={`py-20 ${dark ? "bg-ink" : "bg-cream"}`} data-testid="faq-section">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-3xl mx-auto px-6">
        <h2 className={`font-serif text-3xl md:text-4xl flex items-center gap-3 mb-8 ${dark ? "text-cream" : "text-wine"}`}>
          <HelpCircle className="w-8 h-8 text-gold" /> {heading}
        </h2>
        <Accordion type="single" collapsible className="bg-white rounded-2xl border border-border px-5 shadow-sm">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-medium text-ink hover:text-wine">{f.q}</AccordionTrigger>
              <AccordionContent className="text-ink/70 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
